<template>
    <div class="table-layout" style="height:500px">
        <el-table ref="multipleTable" :data="orderChargeItemList" border tooltip-effect="dark" style="width: 100%">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="price" label="价格(元)" align="right" width="200px;"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import servcDelivApi from '../../api/servcDeliv'

    export default{
        name: 'swb-servc-order-charge-item-list',
        desc: '服务订单收费明细',
        props: ["workId", "orderItemId"],
        data: function () {
            return {
                orderChargeItemList: [],
            }
        },
        created: function () {
            this.getServcOrderChargeItemList();
        },
        methods: {
            getServcOrderChargeItemList: function () {
                let self = this;
                let postData = {};
                postData.workVoucherId = self.workId;
                /*if(!Utils.isNoB(self.orderItemId)) {
                 postData.orderItemId = self.orderItemId;
                 }*/
                servcDelivApi.getServcOrderChargeItemListByWorkVoucherId(postData, function (result) {
                    if(result.type == 'info') {
                        let orderChargeItemList = result.data;
                        if(!Utils.isNoB(orderChargeItemList) && orderChargeItemList.length > 0) {
                            for(let i = 0; i < orderChargeItemList.length; i++) {
                                let orderChargeItem = orderChargeItemList[i];
                                let price = orderChargeItem.price;
                                if(!Utils.isNoB(price)) {
                                    orderChargeItem.price = price.toFixed(2);
                                }
                            }
                        }
                        self.orderChargeItemList = orderChargeItemList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcOrderChargeItemList.vue